import React, { useState } from "react";
import Breadcrumbs from "../based/Breadcrumbs";
import MachineListTab from "./components/MachineListTab";
import ThreadColorTab from "./components/ThreadColorTab";

const TAB = {
    Machine: 1,
    ThreadColor: 2,
};

const TAB_SCREEN = [
    { value: TAB.Machine, label: "Config máy" },
    { value: TAB.ThreadColor, label: "Config màu kim" },
];

function EmbroideryMachineManagement(props) {
    const [tabIndex, setTabIndex] = useState(TAB.Machine);

    function _renderTab() {
        return (
            <ul className='nav nav-tabs tabs-bordered'>
                {TAB_SCREEN.map((item, index) => {
                    return (
                        <li key={index} className='nav-item'>
                            <a className={tabIndex == item.value ? "nav-link active" : "nav-link btn-light"} onClick={() => setTabIndex(item.value)}>
                                <span>{item.label}</span>
                            </a>
                        </li>
                    );
                })}
            </ul>
        );
    }

    return (
        <React.Fragment>
            <Breadcrumbs currentPage='Config Máy thêu/Màu kim' />
            {_renderTab()}
            {tabIndex == TAB.Machine && <MachineListTab {...props} />}
            {tabIndex == TAB.ThreadColor && <ThreadColorTab {...props} />}
        </React.Fragment>
    );
}

export default EmbroideryMachineManagement;
